<template>
  <div class="contract-sales-tab tb">
    <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
    <manage v-if="`${tabIndex}` === '0'"></manage>
    <device-list v-if="`${tabIndex}` === '1'"></device-list>
  </div>
</template>

<script>
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import manage from './children/manage';
import deviceList from './children/deviceList';

export default {
  name: 'agreementOrder',
  props: {},
  components: {
    deviceList,
    manage,
  },
  mixins: [tableFilterValueMixins],
  data() {
    return {
      tabIndex: '',
    };
  },
  computed: {
    tabData() {
      const tabData = [];
      if (this.funcView.sales_contract_list) {
        tabData.push({
          name: this.$t('crm_contractSales.ding_dan'),
          value: 0,
        });
      }
      if (this.funcView.sales_contract_device_list) {
        tabData.push({
          name: this.$t('crm_contractSales.she_bei'),
          value: 1,
        });
      }
      return tabData;
    }
  },
  mounted() {
    this.getFuncView(null, () => {
      // 设置默认选中的tab
      let defaultTabIndex = '';
      if (this.funcView.sales_contract_list) {
        defaultTabIndex = '0';
      } else if (this.funcView.sales_contract_device_list) {
        defaultTabIndex = '1';
      }
      this.tabIndex = this.tabIndex ? this.tabIndex : defaultTabIndex;
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.contract-sales-tab {
  padding-left: 0 !important;
}
</style>
